import { DeviceSummary } from "api/admin/device";
import { useState } from "react";
import {
  DeviceDetailsOverlay,
  deviceOsLabel,
} from "./DeviceDetailsPanel";

const TransactionDevice = ({
  device,
}: {
  device: DeviceSummary | null | undefined;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (device === undefined) return null;

  return (
    <>
      <div className="py-3 mb-5 border-t border-b border-orange-200">
        <p className="text-xs font-medium tracking-wide text-black text-opacity-50 uppercase">
          Device used
        </p>
        {device ? (
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="flex items-center justify-between w-full gap-3 mt-1 text-left rounded focus:outline-none focus:ring-2 focus:ring-orange-300"
          >
            <span>
              <span className="block text-sm font-medium text-gray-900">
                {device.metadata.model || "Unknown model"}
              </span>
              <span className="block text-xs text-gray-500">
                {deviceOsLabel(device)}
              </span>
            </span>
            <span className="text-xs font-medium text-gray-700 underline whitespace-nowrap">
              View device
            </span>
          </button>
        ) : (
          <p className="mt-1 text-sm text-gray-500">Not attributed</p>
        )}
      </div>

      {device && isOpen ? (
        <DeviceDetailsOverlay
          publicId={device.publicId}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  );
};

export default TransactionDevice;
